<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-dialog width="1000px" :value="showUploadAudioDialog" persistent scrollable>
      <v-card class="grey lighten-3">
        <v-toolbar class="primary" dark text>
          <div class="text-h6">Subir Audios</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="toggleUploadAudioDialog()">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-0">
          <NewSpeechToText @cancel="toggleUploadAudioDialog()"/>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog scrollable :value="showAudioInsightsDialog" @input="toggleAudioDialog(false)" fullscreen hide-overlay transition="dialog-bottom-transition">
      <AudioInsights v-if="showAudioInsightsDialog" :insights="projectAudioInsights" :duration="selectedAudioTranscript.duration" :agent="selectedAudioTranscript.agent" :date="selectedAudioTranscript.createdAt" :loadingInsights="loadingAudioInsights" @cancel="toggleAudioDialog(false)"/>
    </v-dialog>
    <v-col class="pt-4" cols="12" >
      <v-row>
        <v-col cols="12">
          <v-tabs
            v-model="tabInsights"
            center-active
            centered
            grow
          >
            <v-tab
              :href="`#tab-insights-1`"
            >
              Insights
            </v-tab>
            <v-tab
              :href="`#tab-insights-2`"
            >
              NLP
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabInsights">
            <v-tab-item :value="'tab-insights-1'">
              <v-row>
                <v-col cols="12">
                  <v-card text color="rgb(255, 0, 0, 0)">
                    <v-card-text class="px-0">
                      <Insights :insights="projectInsights" :loading="loadingInsights"/>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-card>
                    <v-card-text>
                      <v-row class="py-2 px-4" justify="space-between"  >
                        <v-col cols="12">
                          <h3>Audios</h3>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col class="text-right" cols="12" >
                          <v-btn color="primary" @click="toggleUploadAudioDialog()">Subir Audios</v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                      <v-data-table
                        :must-sort="false"
                        :headers="headers"
                        :items="audiosTranscript"
                        class="elevation-0"
                        :loading="loadingAudiosTranscript"
                        :footer-props="{
                          'items-per-page-text': 'Textos por página',
                          'items-per-page-options': [30, 50, 100]
                        }"
                      >
                        <!--
                          :pagination.sync="pagination"
                          :server-items-length="totalAudiosTranscript"
                        -->
                        <template v-slot:item="{ item, index }">
                          <tr>
                            <td>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-avatar v-on="on" v-if="item.status === 'pending'" style="cursor: pointer;"  color="orange" size="10"></v-avatar>
                                </template>
                                <span v-if="item.status === 'pending'">Pendiente</span>
                                <template v-slot:activator="{ on }">
                                  <v-avatar v-on="on" v-if="item.status === 'ready'" style="cursor: pointer;"  color="success" size="10"></v-avatar>
                                </template>
                                <span v-if="item.status === 'ready'">Listo</span>
                              </v-tooltip>
                            </td>
                            <td>{{ item.fileName }}</td>
                            <td>{{ item.language }}</td>
                            <td>{{ item.agent }}</td>
                            <td>{{ item.duration }}</td>
                            <td>{{ convertTZToUserTZ(item.createdAt) | moment('DD/MM/YYYY hh:mma') }}</td>
                            <td class="px-0 mx-0">
                              <div class="data-table-actions d-flex justify-center align-center">
                                <v-btn icon @click="showAudioInsights(item, index)" color="primary" text>
                                  <v-icon>remove_red_eye</v-icon>
                                </v-btn>
                              </div>
                            </td>
                          </tr>
                        </template>

                        <template v-slot:no-data>
                          <v-row>
                            <v-col class="text-center" cols="12" v-if="loadingAudiosTranscript">Cargando Textos</v-col>
                            <v-col cols="12" class="red--text text-center" v-else>Aún no has subido audios</v-col>
                          </v-row>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item :value="'tab-insights-2'">
                <v-row>
                    <v-col cols="12">
                        <v-card text color="rgb(255, 0, 0, 0)">
                            <v-card-text class="px-0">
                                <NLP/>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
// import speechService from '@/services/speechService'
import NewSpeechToText from '@/pages/App/Speech/NewSpeechToText'
import Insights from '@/pages/App/Speech/Insights'
import NLP from '@/pages/App/Speech/NLP'
import AudioInsights from '@/pages/App/Speech/AudioInsights'
import TimeZones from '@/mixins/TimeZones'
export default {
  created () {
    if (!this.selectedProject || !this.selectedProject.id) {
      notifications.error('Seleccione un proyecto')
      this.$router.push(`/apps/${this.$store.getters.appUuid}/speech/projects`)
    }
    this.getProjectInsightsAudios()
  },
  components: { NewSpeechToText, Insights, AudioInsights, NLP },
  computed: {
    ...mapState({
      selectedProject: state => state.speech.selectedProject,
      projectInsights: state => state.speech.projectInsights,
      loadingInsights: state => state.speech.loadingProjectInsights,
      audiosTranscript: state => state.speech.projectAudios,
      totalAudiosTranscript: state => state.speech.totalProjectAudios,
      loadingAudiosTranscript: state => state.speech.loadingProjectAudios,
      selectedAudioTranscript: state => state.speech.selectedAudioTranscript,
      projectAudioInsights: state => state.speech.projectAudioInsights,
      showAudioInsightsDialog: state => state.speech.showAudioInsightsDialog,
      loadingAudioInsights: state => state.speech.loadingAudioInsights
    })
  },
  data () {
    return {
      headers: [
        { text: '', value: 'status' },
        { text: 'Nombre del texto', value: 'fileName' },
        { text: 'Lenguaje', value: 'language' },
        { text: 'Agente', value: 'agent' },
        { text: 'Duración', value: 'duration' },
        { text: 'Fecha de Creación', value: 'createdAt' },
        { text: 'Acciones', align: 'center', sortable: false, value: '' }
      ],
      pagination: {},
      showUploadAudioDialog: false,
      tabInsights: null
    }
  },
  methods: {
    showAudioInsights (audioTranscript, index) {
      // console.log('audioTranscript')
      // console.log(audioTranscript)
      this.$store.commit('SET_SELECTED_AUDIO_TRANSCRIPT', audioTranscript)
      this.$store.dispatch('getAudioInsights')
      this.toggleAudioDialog(true)
    },
    toggleUploadAudioDialog () {
      this.showUploadAudioDialog = !this.showUploadAudioDialog
    },
    toggleAudioDialog (value) {
      this.$store.commit('TOGGLE_AUDIO_INSIGHTS_DIALOG', value)
    },
    getProjectInsightsAudios () {
      this.$store.dispatch('getProject')
    }
  },
  mixins: [TimeZones],
  watch: {
    pagination: {
      handler () {
        this.getProjectInsightsAudios()
        this.$vuetify.goTo(0)
      },
      deep: true
    }
  }
}
</script>
